import ModuleRevealed from './ModuleRevealed';

ModuleRevealed.init(document.getElementById('test'));
